export default "__VITE_ASSET__BSbmG0$g__"